(function () {
  'use strict';

  // Guard: handle do setInterval para evitar stacking se re-init'd
  var _placeholderInterval = null;

  // Modalidade da última interação (teclado vs ponteiro). Usado para decidir se devolvemos
  // o foco visível ao botão ao fechar o drawer: no mouse, devolver o foco programaticamente
  // dispara o anel :focus-visible (quirk do Chrome) e deixa um quadrado ao redor do ícone.
  var _lastInputPointer = false;
  document.addEventListener('pointerdown', function () { _lastInputPointer = true; }, true);
  document.addEventListener('keydown', function () { _lastInputPointer = false; }, true);

  // Handle do closeAll do megamenu (preenchido no initMegamenu) — permite que a busca
  // preditiva feche o megamenu de forma limpa (aria-expanded/current) via StealsHeader.
  var _megamenuCloseAll = null;

  // --- Pocket do status bar (iOS 26+) ---
  // No reload com restauração de scroll (e em voltas via bfcache), o "pocket" do status bar
  // do Safari pode nascer PRESO mostrando o conteúdo capturado (scroll edge effect travado —
  // nem gesto limpa). Um nudge de 1px pós-load força o Safari a reavaliar os fixed container
  // edges e reconstruir o estado (verificado com réplica do Live no simulador iOS 26.5; ST-29).
  // Inofensivo nos demais navegadores; 'instant' ignora scroll-behavior:smooth.
  function nudgeStatusBarPocket() {
    try {
      window.scrollBy({ top: 1, behavior: 'instant' });
      window.scrollBy({ top: -1, behavior: 'instant' });
    } catch (e) {
      window.scrollBy(0, 1);
      window.scrollBy(0, -1);
    }
  }
  // Multi-shot: na rede real o Safari restaura o scroll ASSINCRONAMENTE (pode ser bem depois
  // do load) — um tiro só aos 300ms perde a janela. 3 tiros temporais + 1 tiro ~120ms após o
  // PRIMEIRO evento de scroll (a restauração dispara scroll) cobrem qualquer timing. O nudge
  // é +1/-1 síncrono no mesmo frame → imperceptível mesmo durante scroll do usuário.
  function armStatusBarNudges() {
    [300, 1200, 3000].forEach(function (ms) { setTimeout(nudgeStatusBarPocket, ms); });
    var fired = false;
    function onFirstScroll() {
      if (fired) return;
      fired = true;
      window.removeEventListener('scroll', onFirstScroll);
      setTimeout(nudgeStatusBarPocket, 120);
    }
    window.addEventListener('scroll', onFirstScroll, { passive: true });
  }
  window.addEventListener('load', armStatusBarNudges);
  window.addEventListener('pageshow', function (e) { if (e.persisted) armStatusBarNudges(); });

  // Backer da faixa do notch: precisa estar alto no INSTANTE em que o Safari decide a cor
  // da faixa. No iOS 27 (beta) essa decisão acontece no início do gesto e não é reavaliada
  // durante o scroll (no 26.x é contínua — por isso só o 27 quebrava). Então, além do
  // scroll (mantido, é o caminho do 26.x), o touchstart arma o backer ANTES do pan começar
  // (o dedo encosta ~100ms antes do primeiro frame de scroll). Gate do touchstart: só arma
  // se já rolou OU se o viewport está expandido (altura base > 0 ⇔ env(top) > 0) — em
  // repouso não-expandido a faixa não existe e armar só poria uma tira de 12px no topo
  // pegando o toque do announcement. (Ela não pinta mais: o piso é padding sem pintura,
  // ver section-header.css; pintada, foi a linha branca da v1.1.6→v1.1.9.)
  (function () {
    var backer = document.querySelector('.steals-notch-backer');
    if (!backer) return;
    function updBacker() { backer.classList.toggle('is-active', (window.scrollY || 0) > 2); }
    window.addEventListener('scroll', updBacker, { passive: true });
    window.addEventListener('touchstart', function () {
      if ((window.scrollY || 0) > 2 || parseFloat(getComputedStyle(backer).height) > 0) {
        backer.classList.add('is-active');
      }
    }, { passive: true });
    updBacker();
  })();

  // --- Rotação do placeholder da busca (slide vertical) ---
  // A frase atual sobe e sai; a próxima entra por baixo. O track tem N frases + clone da 1ª
  // (loop contínuo). Esconde quando o campo tem texto. Respeita reduced-motion. Pausa se em uso.
  function initSearchPlaceholder() {
    var input = document.querySelector('[data-search-input]');
    var track = document.querySelector('[data-search-rot-track]');
    if (!input || !track) return;
    var realCount = track.children.length - 1; // último span é clone da 1ª frase
    var form = input.closest('.steals-header__search');

    // marca .has-value p/ esconder o rotator quando há texto digitado (mesmo após blur)
    function syncValue() { if (form) form.classList.toggle('has-value', input.value.trim() !== ''); }
    input.addEventListener('input', syncValue);

    if (realCount < 2) return; // 0 ou 1 frase → sem rotação
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (_placeholderInterval !== null) { clearInterval(_placeholderInterval); }
    var i = 0;
    _placeholderInterval = setInterval(function () {
      if (document.activeElement === input || input.value) return; // pausa se em uso
      i++;
      track.style.transform = 'translateY(-' + (i * 1.5) + 'em)';
      if (i === realCount) {
        // chegou no clone (= 1ª frase): reseta sem animar p/ loop contínuo
        window.setTimeout(function () {
          track.style.transition = 'none';
          track.style.transform = 'translateY(0)';
          i = 0;
          void track.offsetHeight; // força reflow antes de religar a transição
          track.style.transition = '';
        }, 480);
      }
    }, 3000);
  }

  // --- Scrim compartilhado (megamenu + busca preditiva) ---
  // Um único véu; `data-owner` diz quem acendeu. Cada componente só apaga o que é seu.
  function ensureScrim() {
    var scrim = document.querySelector('.steals-header__scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'steals-header__scrim';
      scrim.hidden = true;
      document.body.appendChild(scrim);
    }
    return scrim;
  }

  // --- Megamenu ---
  // Abre/fecha painéis por categoria via hover (delay) e click; Esc fecha e devolve foco; scrim cobre o conteúdo abaixo
  function initMegamenu() {
    var root = document.querySelector('[data-megamenu-root]');
    if (!root) return;
    var openDelay = 120, closeDelay = 200, openT = null, closeT = null, current = null;

    var scrim = ensureScrim();

    function panelFor(handle) { return document.getElementById('megamenu-' + handle); }
    function itemFor(trigger) { return trigger.closest('.steals-header__nav-item'); }

    function open(trigger) {
      if (document.querySelector('.steals-search.is-open')) return;
      var handle = trigger.getAttribute('data-megamenu-trigger');
      if (current === handle) return;
      closeAll(true); // fecha outro painel sem ocultar o scrim ainda
      var panel = panelFor(handle);
      if (!panel) return;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      itemFor(trigger).classList.add('is-open');
      scrim.hidden = false;
      scrim.dataset.owner = 'megamenu';
      current = handle;
    }

    function closeAll(skipScrim) {
      root.querySelectorAll('[data-megamenu-trigger]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        itemFor(t).classList.remove('is-open');
      });
      root.querySelectorAll('[data-megamenu-panel]').forEach(function (p) { p.hidden = true; });
      if (!skipScrim && scrim.dataset.owner !== 'search') {
        scrim.hidden = true;
        delete scrim.dataset.owner;
      }
      current = null;
    }
    _megamenuCloseAll = closeAll;

    root.querySelectorAll('[data-megamenu-trigger]').forEach(function (trigger) {
      var item = itemFor(trigger);

      // hover: abre com delay, fecha com delay
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeT);
        openT = setTimeout(function () { open(trigger); }, openDelay);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openT);
        closeT = setTimeout(function () { closeAll(); }, closeDelay);
      });

      // click / teclado: no mobile navega para a coleção; no desktop alterna o painel
      trigger.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 749px)').matches) {
          var href = trigger.getAttribute('data-href');
          if (href) { window.location.href = href; }
          return;
        }
        clearTimeout(openT);
        clearTimeout(closeT);
        if (trigger.getAttribute('aria-expanded') === 'true') { closeAll(); }
        else { open(trigger); }
      });
    });

    // Scrim: fechar ao hover ou click no overlay
    scrim.addEventListener('mouseenter', function () { closeAll(); });
    scrim.addEventListener('click', function () { closeAll(); });

    // Teclado: Esc fecha e devolve foco ao trigger
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) {
        var t = root.querySelector('[data-megamenu-trigger="' + current + '"]');
        closeAll();
        if (t) t.focus();
      }
    });
  }

  // --- Menu Drawer (estrutura padrão própria) ---
  // Botão MENU abre o drawer; X, overlay e Esc fecham. Lock de scroll no body.
  function initMenuDrawer() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var openBtn = document.querySelector('[data-nav-drawer-trigger]');
    if (!drawer || !openBtn) return;
    var closeBtn = drawer.querySelector('.steals-menu-drawer__close');

    // Lock de scroll robusto: o iOS Safari IGNORA `overflow:hidden` no body (o fundo
    // continua rolando atrás do drawer). A trava confiável é `position:fixed` no body,
    // guardando e restaurando o scrollY.
    var savedScrollY = 0;
    function lockScroll() {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-savedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);
    }

    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      lockScroll();
      openBtn.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      unlockScroll();
      openBtn.setAttribute('aria-expanded', 'false');
      // Devolve o foco ao botão só quando o fechamento veio do teclado (Esc ou Enter no X).
      // No mouse, o foco volta naturalmente p/ o body — evita o anel :focus-visible no ícone.
      if (!_lastInputPointer) openBtn.focus();
      // espera a transição antes de ocultar (mantém o slide-out)
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 260);
    }

    openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    drawer.querySelectorAll('[data-menu-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // accordion: categorias com "+" expandem/recolhem as subcategorias
    drawer.querySelectorAll('[data-acc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var sub = btn.nextElementSibling;
        if (sub) sub.hidden = expanded;
      });
    });

    // abas de categoria: alterna o painel visível (macro) mantendo o accordion de cada aba
    var tabs = drawer.querySelectorAll('.steals-menu-drawer__tab');
    var panels = drawer.querySelectorAll('[data-tab-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-hidden', p.getAttribute('data-tab-panel') !== key);
        });
      });
    });
  }

  // Sticky agora é 100% CSS (position:sticky na section, ver header.liquid). O antigo
  // initMobileStickyMain (pin via JS togglando position:fixed) foi removido: era frágil no
  // iOS (não repintava o fixo durante o scroll de inércia → "piscava" mostrando o conteúdo
  // atrás na faixa do notch) e dependia de um sentinel que o `div:empty` do base.css escondia.

  // --- Inicialização ---
  function initAll() {
    initSearchPlaceholder();
    initMegamenu();
    initMenuDrawer();
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  window.StealsHeader = {
    initSearchPlaceholder: initSearchPlaceholder,
    initMegamenu: initMegamenu,
    ensureScrim: ensureScrim,
    closeMegamenu: function (skipScrim) { if (_megamenuCloseAll) _megamenuCloseAll(skipScrim); }
  };
})();
